// Components==============
import sendEmail from 'actions/mail/send';
import Button from 'components/UI/Button';
import Checkbox from 'components/UI/Checkbox';
import { UploadButton } from 'components/UI/Form/File';
import { Options, TextAreaInput, TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { StoreContext } from 'utilities/StoreContextWrapper';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';
// =========================

export default function InterviewModal() {
    const [agreed, setAgreed] = useState(false);
    const [displayMessage, setDisplayMessage] = useState('');
    const [mailConfirm, setMailConfirm] = useState('');

    const { formValues, handleChange, setFormValues } = useFormValues(
        {
            name: '',
            mail: '',
            phone: '',
            interests: '',
            files: [],
            to: [],
        },
        () => setMailConfirm('')
    );

    function deleteFile(index) {
        const newFiles = Array.from(files);
        if (index > -1) {
            newFiles.splice(index, 1);
        }

        setFormValues({
            ...formValues,
            files: newFiles,
        });
    }

    const dispatch = useDispatch();

    const closeUrlModal = useCloseUrlModal();

    const { name, mail, phone, interests, files, to } = formValues;

    function handleSubmit(e) {
        e.preventDefault();

        if (mail !== mailConfirm)
            return setDisplayMessage('De email adressen komen niet overeen');

        if (agreed) {
            // // Prepare request
            const formData = new FormData();
            const fields = Object.keys(formValues);
            fields.map((field) => {
                if (field == 'files') {
                    console.log(formValues[field]);

                    const { length } = formValues[field];

                    for (let x = 0; x < length; x++) {
                        formData.append('files[]', formValues[field][x]);
                    }
                } else {
                    formData.append(field, formValues[field]);
                }
            });
            formData.append('type', 'sollicitatie');
            setDisplayMessage('Uw bericht wordt verzonden...');
            dispatch(sendEmail(formData)).then((r) => {
                closeUrlModal();
            });
        } else {
            setDisplayMessage(
                'Je moet akkoord gaan voordat je je sollicitatie kun versturen'
            );
        }
    }

    const { schoolGroups } = useContext(StoreContext);

    return (
        <Modal slug="open-sollicitatie-popup">
            <div styleName="content">
                <h2>Open sollicitatie</h2>
                <form onSubmit={handleSubmit}>
                    <div styleName="column">
                        <div>
                            <TextInput
                                label="Naam *"
                                name="name"
                                value={name}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <TextInput
                                label="E-mailadres *"
                                name="mail"
                                type="email"
                                value={mail}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <TextInput
                                label="E-mailadres bevestiging *"
                                name="mailConfirm"
                                type="email"
                                value={mailConfirm}
                                onChange={(e) => {
                                    setDisplayMessage('');
                                    setMailConfirm(e.target.value);
                                }}
                            />
                        </div>
                        <div>
                            <TextInput
                                label="Telefoonnummer *"
                                name="phone"
                                type="phone"
                                value={phone}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <TextAreaInput
                                label="interesse in functie/vakgebied *"
                                name="interests"
                                value={interests}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div styleName="column">
                        <div>
                            <UploadButton
                                label="Bestanden uploaden"
                                name="files"
                                onChange={handleChange}
                                value={files}
                                onDelete={deleteFile}
                                required={false}
                            />
                        </div>
                        <div>
                            <Options
                                options={schoolGroups
                                    .filter(
                                        (schoolGroup) =>
                                            schoolGroup.hide_from_contact === 0
                                    )
                                    .map((school) => school.name)}
                                label="stuur sollicitatie naar:"
                                setSelected={setFormValues}
                                selected={to}
                            />
                        </div>
                    </div>
                    <div styleName="bottom">
                        <div
                            onClick={() => setAgreed((prev) => !prev)}
                            styleName="agreeBox"
                        >
                            <Checkbox isSelected={agreed} />
                            <p>
                                Ik ga akkoord met het beheer en de verwerking
                                van mijn gegevens. De scholen werken conform de
                                AVG wet- en regelgeving en de
                                NVP-sollicitatiecode. Voor meer informatie
                                hierover kan contact worden opgenomen met de
                                desbetreffende school.
                            </p>
                        </div>
                        {displayMessage && (
                            <p styleName="error">{displayMessage}</p>
                        )}
                        <div>
                            <Button>Verzenden</Button>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
